import availableUnits from './available_units'
import clanUnits from './clan_units'
import joinUnit from './join_unit'
import unitCreate from './unit_create'
import unitCreateInfo from './unit_create_info'
import unitParticipants from './unit_participants'
import unitRebuild from './unit_rebuild'
import unitRebuildInfo from './unit_rebuild_info'

export const reducers = {
    availableUnits,
    clanUnits,
    joinUnit,
    unitCreate,
    unitCreateInfo,
    unitParticipants,
    unitRebuild,
    unitRebuildInfo,
}



// WEBPACK FOOTER //
// ./state/reducers/units/index.js